import { createAction, props } from '@ngrx/store';
import { ReportDomain } from '@mode/shared/contract-common';

export const loadReportParameterOptions = createAction(
  '[ReportParameterOptions] LoadReportParameterOptions',
  props<{
    accountId: string;
    reportToken: string;
    reportRunToken: string;
  }>()
);

export const loadReportParameterOptionsSuccess = createAction(
  '[ReportParameterOptions] LoadReportParameterOptionsSuccess',
  props<{
    options: ReportDomain.ReportRunFormFieldOptions[];
  }>()
);

export const loadReportParameterOptionsFailure = createAction(
  '[ReportParameterOptions] LoadReportParameterOptionsFailure',
  props<{ error: any }>()
);

export type Union =
  | ReturnType<typeof loadReportParameterOptions>
  | ReturnType<typeof loadReportParameterOptionsFailure>
  | ReturnType<typeof loadReportParameterOptionsSuccess>;
